import { BillingStatus } from '../billing/billing-status';

export interface VendorBillPaginated {
  id: string;
  projectNumber: string;
  referenceNumbers: string;
  invoiceNumber: string;
  billId: string;
  billIssuedDate: number;
  dueDate: number;
  billPaidDate: number;
  amount: number;
  status: BillingStatus;
  vendorId: number;
  referenceNumberString: string;
  referenceNumberIsCountry: boolean;
  orderId: number;
  additionalBill: boolean;
  // NOTE: These items should always be the same as the ones below in VendorBillPaginatedFields
}

export enum VendorBillPaginatedFields {
  id = 'id',
  projectNumber = 'projectNumber',
  referenceNumbers = 'referenceNumbers',
  invoiceNumber = 'invoiceNumber',
  billId = 'billId',
  billIssuedDate = 'billIssuedDate',
  dueDate = 'dueDate',
  billPaidDate = 'billPaidDate',
  amount = 'amount',
  status = 'status',
  vendorId = 'vendorId',
  referenceNumberString = 'referenceNumberString',
  referenceNumberIsCountry = 'referenceNumberIsCountry',
  orderId = 'orderId',
  additionalBill = 'additionalBill',
  // NOTE: These items should always be the same as the ones above in VendorBillPaginated
}
